import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step_3_1 from "@/assets/integration-steps/meta/step_3_1.png";
import step_3_2 from "@/assets/integration-steps/meta/step_3_2.png";

interface Props {
  stepLabel?: string;
}

const MetaIntegrationStep3 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step meta-step-3">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>Select the exclusion event</h6>
    </div>
    <div className="step-label-row">
      <p>
        Select the event <b>"OpticksExcludeVisitor"</b> that you will find at
        the end of the dropdown.
        <br />
        <br />
        Please make sure that OpticksExcludeVisitor event has been confirmed for
        usage. You can find more{" "}
        <OpticksLink
          href="https://www.facebook.com/business/help/642275438032995"
          label="information here"
        />
      </p>
    </div>
    <img src={step_3_1} alt="Screenshot of step 3.1 Meta Integration" />
    <p>
      Select an audience retention of <b>75 days</b> and finish the process.
    </p>
    <img src={step_3_2} alt="Screenshot of step 3.2 Meta Integration" />
  </div>
);

export default MetaIntegrationStep3;
